'use client';

import React from 'react';
import CustomerSupport from 'components/commercetools-ui/organisms/customer-support'; // Assuming the base component is in components folder
import { CustomerSupportProps } from 'components/commercetools-ui/organisms/customer-support/types';
import { TasticProps } from '../../types';

const CustomerSupportTastic = ({ data }: TasticProps<CustomerSupportProps>) => {
  return <CustomerSupport {...data} />;
};

export default CustomerSupportTastic;
